import MDescriptionListItem from "./MDescriptionListItem.vue";

export default MDescriptionListItem;
